module.exports = __webpack_public_path__ + "img/sign_220220562_1.6021f8cb.png";